export type PermissionCheck = (
  application: string,
  feature: string,
  category: string,
) => boolean;

export type AttributePermissionCheck = (
  application: string,
  feature: string,
  attribute: string,
) => boolean;

/** Select the first Platform Settings page the current user can actually open. */
export function getPlatformSettingsLanding(
  has: PermissionCheck,
  hasAttribute: AttributePermissionCheck,
): string | null {
  if (has("PLATFORM_SETTINGS", "PROJECT_MANAGEMENT", "Read")) {
    return "/platform-settings/projects";
  }
  if (has("PLATFORM_SETTINGS", "ENVIRONMENT_MANAGEMENT", "Read")) {
    return "/platform-settings/environment";
  }
  if (has("PLATFORM_SETTINGS", "ROLE_MANAGEMENT", "Read")) {
    return "/platform-settings/roles-permissions";
  }
  if (has("PLATFORM_SETTINGS", "CLIENT_MANAGEMENT", "Read")) {
    return "/platform-settings/client";
  }
  if (has("PLATFORM_SETTINGS", "API_KEY_MANAGEMENT", "Read")) {
    return "/platform-settings/api-keys";
  }
  if (hasAttribute("PLATFORM_SETTINGS", "USER_MANAGEMENT", "ViewUsers")) {
    return "/platform-settings/application-users/users";
  }
  if (hasAttribute("PLATFORM_SETTINGS", "USER_MANAGEMENT", "ViewInvitations")) {
    return "/platform-settings/application-users/invite-users";
  }
  if (has("PLATFORM_SETTINGS", "BILLING_USAGE", "Billing")) {
    return "/platform-settings/billing/overview";
  }
  if (has("PLATFORM_SETTINGS", "BILLING_USAGE", "Add-ons")) {
    return "/platform-settings/billing/addons";
  }
  if (hasAttribute("PLATFORM_SETTINGS", "BILLING_USAGE", "ManageBillingDetails")) {
    return "/platform-settings/billing/details";
  }
  if (has("PLATFORM_SETTINGS", "BILLING_USAGE", "Invoices")) {
    return "/platform-settings/billing/history";
  }
  if (has("PLATFORM_SETTINGS", "BILLING_USAGE", "Usage")) {
    return "/platform-settings/usage/overview";
  }
  if (has("PLATFORM_SETTINGS", "BILLING_USAGE", "Alerts")) {
    return "/platform-settings/usage/alerts";
  }
  return null;
}
